module.exports = __webpack_public_path__ + "static/media/login_bg.9b508b24.png";